<kendo-splitter orientation="vertical" class="h-100">
  <kendo-splitter-pane size="55%">
    <app-fsp-buildings-grid> </app-fsp-buildings-grid>
  </kendo-splitter-pane>
  <kendo-splitter-pane>
    <kendo-tabstrip class="h-100" [keepTabContent]="true">
      <kendo-tabstrip-tab
        title="{{ 'FREE_PORTAL_SERVICES.DOCS' | translate }}"
        [selected]="true"
      >
        <ng-template kendoTabContent>
          <app-fsp-buildings-documents-grid></app-fsp-buildings-documents-grid>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab
        title="{{ 'FREE_PORTAL_SERVICES.OWNERS' | translate }}"
      >
        <ng-template kendoTabContent>
          <app-fsp-buildings-owners-grid></app-fsp-buildings-owners-grid>
        </ng-template>
      </kendo-tabstrip-tab>
      )
    </kendo-tabstrip>
  </kendo-splitter-pane>
</kendo-splitter>
